import image from "../../assets/images/bg/bg-lines-one.png";

export const Loading = () => {
  return (
    <section
      className="bg-home d-flex bg-light align-items-center"
      style={{
        backgroundImage: `url(${image})`,
        backgroundPosition: "center",
      }}
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-7 col-md-10 text-center">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <div>Cargando...</div>
          </div>
        </div>
      </div>
    </section>
  );
};
